import Header from "@/components/Header/components";
import FormsMixin from "@/mixins/FormsMixin";
import { CLIENTES } from "@/store/modules/SeleccionCliente/types";
import { Component } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import Template from "./template.vue";
import { FACTURA, FECHAS, LSTFACTURAS } from "@/store/modules/Facturas/types";
import { DataTableHeader } from "vuetify";

@Component({
  mixins: [Template],
  components: { Header }
})
export default class FacturasPdf extends FormsMixin {
  @Action("listarFacturas", { namespace: "facturas" }) listarFacturas!: Function;
  @Action("GetPdf", { namespace: "facturas" }) GetPdfFactura!: Function;
  @Action("loadConfig", { namespace: "facturas" }) loadConfig!: Function;
  @Action("listarArticulos", { namespace: "ventas" }) listarArticulos!: Function;
  @Action("listarArticulosFiltrado", { namespace: "ventas" }) listarArticulosFiltrado!: Function;
  @Action("postActualizaFavorito", { namespace: "ventas" }) postActualizaFavorito!: Function;
  @State('isMobile') isMobile!: boolean;


  public listadoFacturas: LSTFACTURAS = {
    totalLength: 0,
    lstFacturas: []
  };
  public DialogArticulos = false;
  public DialogCambioCliente = false;
  public EsCliente = false;
  public Favoritos = false;
  public page = 0;
  public search = "";
  public fecMin = "";
  public fecMax = "";
  public expand = "N";
  public totalElementos = 0;
  public itemsPorPaginaHistorico = 10;
  public paginationHistorico = {
    page: 1,
    itemsPerPage: this.itemsPorPaginaHistorico
  };
  public fechas: FECHAS = {
    FECMAX: "",
    FECMIN:""
  }
  public cliente: CLIENTES = {
    CODCLI: "",
    NOMCLI: "",
    AT_APP: "",
    AT_PASSWORD: "",
    CODREP: "",
    E_MAIL: "",
    NIFCLI: ""
  };

  public headersFacturas: Array<DataTableHeader> = [
    {
      text: "Num. Factura",
      value: "NUMDOC"
    },
    {
      text: "Fecha",
      value: "FECHA",
    },
    {
      text: "Referencia",
      value: "REFERENCIA",
    },
    
    {
      text: "Total",
      value: "TOTDOC",
    },
    {
      text: "DESCARGAR PDF",
      value: "PDF",
    }
  ];

  async mounted() {
    this.$root.$emit("loading", true);
    this.cliente = JSON.parse(localStorage.getItem('CliePedido') || '{}');
    this.EsCliente = JSON.parse(localStorage.getItem('userLogged') || '{}').esCliente;

    this.fechas = await this.loadConfig();

    this.fecMax = this.fechas.FECMAX;
    this.fecMin = this.fechas.FECMIN;

    //@ts-ignore
    if (this.cliente == undefined || this.cliente.CODCLI == undefined) {
      this.$router.push("seleccionCliente");
    }
    // } else {
    //   this.listadoFacturas = await this.listarFacturas({ codcli: this.cliente.CODCLI, fechaMin: this.fecMin, fechaMax: this.fecMax, referencia: this.search });
    // }
    this.$root.$emit("loading", false);
    window.scrollTo(0, 0);
  }

  async AplicarFiltros(){
    this.expand = "N";
    this.$root.$emit("loading", true);
    //@ts-ignore
    if (this.cliente == undefined || this.cliente.CODCLI == undefined) {
      this.$router.push("seleccionCliente");
    } else {
      this.listadoFacturas = await this.listarFacturas({ codcli: this.cliente.CODCLI, fechaMin: this.fecMin, fechaMax: this.fecMax, referencia: this.search, page: this.page, itemsPage: this.itemsPorPaginaHistorico });
      console.log(this.listadoFacturas);
      this.totalElementos = this.listadoFacturas.totalLength;
      console.log(this.totalElementos);
    }
    this.$root.$emit("loading", false);
    window.scrollTo(0, 0);
  }

  async downloadPDF(item: FACTURA) {
    if(item.HAY_PDF){
      const fileInfo = await this.GetPdfFactura({ruta: item.PDF_RUTA});
      const linkSource = `data:application/pdf;base64,${fileInfo}`;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = item.PDF_RUTA;
      downloadLink.click();
    }
    
  }

  toggleMostrarCesta() {
    this.$root.$emit("toggleShowCart");
  }

  addHoursToDate(objDate: Date, intHours: number) {
    const numberOfMlSeconds = objDate.getTime();
    const addMlSeconds = (intHours * 60) * 60000;
    const newDateObj = new Date(numberOfMlSeconds + addMlSeconds);
    return newDateObj;
}

  CerrarSession() {
    this.$root.$emit("cerrarSesion");
  }

  showButtons(item: any) {
    return item.children == null
  }

  HistoricoArticulos() {
    this.$router.push({ name: "Historico" });
  }

  MuestraDialogCambioCliente() {
    this.DialogCambioCliente = true;
  }

  OcultaDialogCambioCliente() {
    this.DialogCambioCliente = false;
  }

  VuelveSeleccionUsuario() {
    this.$root.$emit("quitarCliente")
    this.$router.push({ name: "SeleccionCliente" });
  }

  removeHours(datetime: string) {
    return datetime.substring(0, 10);
  }

  EsAccesoCliente() {
    return (this.EsCliente == false)
  }

  MostrarFavoritos() {
    if (this.$router.currentRoute.name != "venta") this.$router.push({ name: "venta", query: { favoritos: "true" } });
  }

  MostrarPrincipal() {
    if (this.$router.currentRoute.name != "venta") this.$router.push({ name: "venta" });
  }
//@ts-ignore
  async loadPedidosWithOptions({page, itemsPerPage}) {
    const params = {page, itemsPerPage}
    this.itemsPorPaginaHistorico = params.itemsPerPage

    page = params.page;
    if(this.fechas.FECMAX == "" ){
      this.fechas = await this.loadConfig();

    this.fecMax = this.fechas.FECMAX;
    this.fecMin = this.fechas.FECMIN;
    }

    this.listadoFacturas = await this.listarFacturas({ codcli: this.cliente.CODCLI, fechaMin: this.fecMin, fechaMax: this.fecMax, referencia: this.search, page: params.page, itemsPage: params.itemsPerPage });
    this.totalElementos = this.listadoFacturas.totalLength;
    
    // this.responseHistorico = await this.getListadoHistorico({
    //   itemsPage: this.itemsPorPaginaHistorico,
    //   page: this.paginationHistorico.page,
    //   orderColumn: params.sortBy?.length > 0 ? params.sortBy[0] : "",
    //   order: params.sortDesc?.length > 0 ? params.sortDesc[0] : false,
    //   codcli: this.filtroCliente == null ? "" : this.filtroCliente.CODCLI
    // })
  }
}